import { render } from "./PartnersProfile.vue?vue&type=template&id=10a29a91&scoped=true"
import script from "./PartnersProfile.vue?vue&type=script&lang=js"
export * from "./PartnersProfile.vue?vue&type=script&lang=js"

import "./PartnersProfile.vue?vue&type=style&index=0&id=10a29a91&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10a29a91"]])

export default __exports__